import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  is_loaded_push_notification: false,
  push_notification: false,
  smtp_details: {},
  is_autoresponder_loaded: false,
  autoresponder: {},
};

const settingSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setPusNotification(state, action) {
      state.push_notification = action.payload.push_notification;
      state.is_loaded_push_notification =
        action.payload?.is_loaded_push_notification;
    },
    setSMTPDetails(state, action) {
      state.smtp_details = action.payload.smtp_details;
    },
    setAutoresponder(state, action) {
      state.autoresponder = action.payload.autoresponder;
      state.is_autoresponder_loaded = true;
    },
    setAutoresponderStatus(state, action) {
      state.is_autoresponder_loaded = action.payload.status;
    },
  },
});

export const settingAction = settingSlice.actions;
export default settingSlice.reducer;
